export default __webpack_public_path__ + "static/innovation-hero-9a14994f9320fc8cfe8f97bcab1fbbe0.svg";